module.exports = __webpack_public_path__ + "img/nosquirrel.b2ca4f63.png";